/**
 * Shared types and utilities for icons
 * @module components/icons/shared
 */

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface IconProps {
  className?: string;
  size?: IconSize;
}

export const sizeClasses: Record<IconSize, string> = {
  xs: 'size-3',
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-6',
  xl: 'size-8',
};

export interface IconWithBackgroundProps extends IconProps {
  color: 'blue' | 'purple' | 'amber' | 'green' | 'red' | 'cyan' | 'gray';
  children: React.ReactNode;
}

export const backgroundColors: Record<IconWithBackgroundProps['color'], string> = {
  blue: 'bg-blue-500/10',
  purple: 'bg-purple-500/10',
  amber: 'bg-amber-500/10',
  green: 'bg-green-500/10',
  red: 'bg-red-500/10',
  cyan: 'bg-cyan-500/10',
  gray: 'bg-gray-500/10',
};
